import { render, staticRenderFns } from "./playlistVideos.vue?vue&type=template&id=270fd525&"
import script from "./playlistVideos.vue?vue&type=script&lang=js&"
export * from "./playlistVideos.vue?vue&type=script&lang=js&"
import style0 from "./playlistVideos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "playlistVideos.vue"
export default component.exports